// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginatorWrapper__container--2VN-Z","flex":"PaginatorWrapper__flex--10yos","flexEnd":"PaginatorWrapper__flexEnd--1V7yw PaginatorWrapper__flex--10yos"};